import * as contentful from 'contentful';

const space = process.env.REACT_APP_API_SPACE;
const nekot = process.env.REACT_APP_ACCESS_TOKEN;

export const client = contentful.createClient( {
  space: space,
  accessToken: nekot
} );